import { connect } from 'react-redux'

import { showTransientNotification } from '@driftt/traffic-control'
import AllSegments from 'components/Segments'
import {
  deselectSegment,
  filterSegmentType,
  receiveSegments,
  selectSegment
} from 'modules/segments/actions'

const mapStateToProps = state => {
  return {
    orgId: state.user.orgId,
    segments: state.__CRM.segments.segments,
    selectedSegments: state.__CRM.segments.selectedSegments,
    users: state.org.users,
    filteredSegmentType: state.__CRM.segments.filteredSegmentType
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onReceiveSegments: segments => {
      dispatch(receiveSegments(segments))
    },
    showTransientNotification: config => {
      dispatch(showTransientNotification(config))
    },
    onSelectSegment: segment => {
      dispatch(selectSegment(segment))
    },
    onDeselectSegment: segment => {
      dispatch(deselectSegment(segment))
    },
    onFilterSegmentType: type => (
      dispatch(filterSegmentType(type))
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AllSegments)
